import { useMutation, useQueryClient } from '@tanstack/react-query';
import { maintenanceService, type ReceiveFromMaintenanceParams } from '@/services/maintenance';
import { queryKeys } from '@/lib/queryKeys';
import { useNotifications } from '@/stores/useNotificationStore';
import { getErrorMessage } from '@/utils/httpClient';

export const useReceiveFromMaintenance = () => {
  const queryClient = useQueryClient();
  const notifications = useNotifications();

  return useMutation({
    mutationFn: (params: ReceiveFromMaintenanceParams) =>
      maintenanceService.receiveFromMaintenance(params),
    onSuccess: (result) => {
      notifications.success(
        'Received from maintenance',
        `${result.receivedCount} asset${result.receivedCount === 1 ? '' : 's'} returned to stock`,
      );
      void queryClient.invalidateQueries({ queryKey: ['asset-inventory'] });
      void queryClient.invalidateQueries({ queryKey: queryKeys.maintenanceRequests.all });
    },
    onError: (error) => {
      notifications.error('Failed to receive from maintenance', getErrorMessage(error));
    },
  });
};
